const colors = [
  "#F7CE6B", "#5752BE", "#F25457", "#55A1E5", "#BFBC6C", "#F2A254",
  "#BF7A6C", "#6CBDBF", "#ED6D85", "#AECEB7", "#916CF6", "#92393A",
  "#BFC5D5", "#52BE8B", "#D483D3", "#365A50", "#E6B45C", "#6A65CC",
  "#E17075", "#69B8E2", "#C6C073", "#F4B476", "#C98D7A", "#7CCFCC",
  "#F191A1", "#B9D5C9", "#A58EF7", "#A14E4E", "#D5D9E5", "#65D2A0",
  "#DD9CDA", "#46776F", "#F1C86A", "#5B56C5", "#F06B6E", "#61ADE8",
  "#C7C16F", "#F3A962", "#C38570", "#73C6C4", "#EF7D91", "#B4D3C3",
  "#9C76F9", "#984645", "#C5CADA", "#5ACB93", "#DA8AD7", "#3B655A",
  "#F9D16E", "#605ACC", "#F46A63", "#60A7E3", "#C4BF6E", "#F5AA68",
  "#C48878", "#78C3C1", "#F38395", "#B6D9CC", "#A57BF7", "#9A494A",
  "#C8CCDD", "#5FD59A", "#DF92DD", "#426B61", "#FAD672", "#665FCE",
  "#F66F6B", "#64AEE6", "#CCC672", "#F7B06E", "#CD8F7D", "#7FCAC7",
  "#F595A7", "#BEDDD1", "#AD82F9", "#9E4F4F", "#D1D3E2", "#64DCA2",
  "#E39AE2", "#497167", "#FBDA75", "#6A63D2", "#F87371", "#68B3EA",
  "#D1CB76", "#F9B674", "#D29582", "#84CFCC", "#F8A1AF", "#C4E2D6",
  "#B289FB", "#A25555", "#D6D9E6", "#68E1AA", "#E7A3E7", "#4E7870",
  "#FCDE79", "#6F68D6", "#FB7879", "#6CB8ED", "#D6D17A", "#FCBC7A",
  "#D69B87", "#89D4D1", "#F9AAB8", "#CACFCC", "#888888"
];

export function generateColors(amount: number): string[] {
  const base = colors.length;
  if (amount <= base) return colors.slice(0, amount);
  const extra = Array(amount - base).fill("#888888");
  return colors.concat(extra);
}